<template>
  <table>
    <thead class="bg-n-600 h-12">
      <tr>
        <th class="px-2 align-middle text-left font-normal rounded-l">
          {{ t('couriers.identifier') }}
        </th>
        <th class="w-1/3 px-2 align-middle text-left font-normal">
          {{ t('couriers.address') }}
        </th>
        <th class="px-2 align-middle text-left font-normal">
          {{ t('couriers.pickup-delivery') }}
        </th>

        <th class="px-2 align-middle text-left font-normal">
          {{ t('couriers.payment-method') }}
        </th>
        <th class="px-2 align-middle text-left font-normal rounded-r">
          {{ t('couriers.total') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in report" :key="row.code">
        <td class="p-2">
          {{ row.code }}
        </td>
        <td class="p-2">
          {{ row.address }}
        </td>
        <td class="p-2">
          <div class="flex flex-col">
            <div>
              {{ format(row.creationTime, 'dd/MM/yyyy - HH:mm') }}
            </div>
            <div v-if="row.closeTime">
              {{ format(row.closeTime, 'dd/MM/yyyy - HH:mm') }}
            </div>
          </div>
        </td>
        <td class="p-2">
          {{ getPaymentMethodLabel(row.paymentMethod) }}
        </td>
        <td class="p-2">
          {{ currency(row.total) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import { useI18n } from 'vue-i18n'

import { useMoney } from '@/composables/useMoney'
import type { CourierTab } from '@/types'

withDefaults(
  defineProps<{
    report?: CourierTab[]
  }>(),
  {
    report: () => []
  }
)

const { t } = useI18n()
const { currency } = useMoney()

function getPaymentMethodLabel(method: string) {
  switch (method) {
    case 'cash':
      return t('couriers.cash')
    case 'card':
      return t('couriers.card')
    default:
      return method
  }
}
</script>
